import styled from 'styled-components';
import {Row} from '../../common/Layouts/Layouts';
import {BaseColumnWrap} from '../../../CommonStyleUtils/dwebCommon.styles';
import {textSizes} from '@stencil/build-theme';

// HOVER STUFF

export const HiddenDropdownWrapperDiv = styled.div`
  width: ${props => props.width || '20rem'};
  ${props => (props.top ? 'top: 1.5rem;' : 'bottom: 2rem;')}
  right: ${props => props.right || '-2rem'};
  max-width: ${props => props.width || '30rem'};
  padding: ${props => props.theme.spacing.base} 0;
  z-index: ${props => props.theme.misc.zIndex.base};
  visibility: hidden;
  transition: opacity 0.8s;
  position: absolute;
`;

export const HoverTargetWrapperDiv = styled.div`
  position: relative;
  text-align: left;
  display: inline-flex;
  /* align-self: flex-start; */
  &:hover > ${HiddenDropdownWrapperDiv} {
    visibility: visible;
  }
`;

export const TopDiv = styled.div(
  props => `
background-color: ${props.theme.colors.goBrandBlue.light};
border-radius: ${props.theme.misc.borderRadius.base};
box-shadow: 0 ${props.theme.spacing.xxsmall} ${props.theme.spacing.custom(4)} ${
    props.theme.colors.shadow.base
  };
`,
);

export const TipUI = styled.div`
  position: absolute;
  margin-left: -${props => props.theme.spacing.base};
  width: 2.4rem;
  height: 1.2rem;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    width: 1.3rem;
    height: 1.2rem;
    left: 50%;
    background: ${props => props.theme.colors.goBrandBlue.medium};
  }
`;

export const TipPositioning = styled(TipUI)`
  right: 15%;
  top: -0.2rem;
  &::after {
    transform: translate(-50%, 50%) rotate(45deg);
    background: ${props => props.bgColor};
    box-shadow: 0 ${props => props.theme.spacing.xxsmall} ${props => props.theme.spacing.custom(4)}
      ${props => props.theme.colors.shadow.base};
  }
`;

// CONTENT STUFF

export const ListDropDownWrapper = styled(BaseColumnWrap)(
  props => `
list-style-type: none;
overflow: hidden;
padding: ${props.theme.spacing.small} 0 0;
background:${props.theme.colors.goBrandBlue.medium}
> li {
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  padding: ${props.theme.spacing.base};
  position: relative;
  &:last-child {
    border-bottom: none;
  }
}
`,
);

// CONTENT STUFF

export const IconWrapperDiv = styled.div`
  display: flex;
  padding: ${props => props.padding || props.theme.spacing.base};
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
`;

export const TextWrapper = styled.p`
  ${textSizes.SmallW1}
  padding-left: ${props => (props?.ccd && '0rem') || props.theme.spacing.custom(8)};
  color: ${props => props?.ccd?.tc || props.theme.colors.downriver.dark};
`;

export const TextBlockDDHeading = styled(Row)`
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  padding: ${props => props.theme.spacing.custom(3)} ${props => props.theme.spacing.base}
    ${props => props.theme.spacing.custom(3)} ${props => props.theme.spacing.small};
  background-color: white;
  color: ${props => props.theme.colors.goBrandBlue.base};
  border-radius: 2.5rem;
`;

export const TextBlockDDHeadingSpan = styled.span`
  color: ${props => props.color};
  background-color: ${props => props.bgColor};
  /* color: ${props => props.color || props.theme.colors.goGreen.base}; */
`;

export const MiniIconWrapperSpan = styled.span`
  margin-right: ${props => props.theme.spacing.small};
`;

export const AmenitiesHoverTitleSpan = styled.span`
  ${textSizes.SmallW1}
  margin-bottom: 1rem;
`;
